import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";

import AddExpense from "./AddExpense";
import { loadExpensesByReporting } from "../../redux/rtk/features/expense/expenseSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import "./Expense.css";

const Expense = (props) => {
	const dispatch = useDispatch();
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const [expenseModalOpen, setExpenseModalOpen] = useState(false);
	const employeeId = getUserFromToken();

	useEffect(() => {
		if (isLogged && employeeId) {
			dispatch(loadExpensesByReporting(employeeId));
		}
	}, [dispatch, isLogged, employeeId]);

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		<div className="expense-page-container">
			<div className="flex justify-between items-center mb-4">
				<span />
				<Button
					type="primary"
					className="expense-apply-btn"
					onClick={() => setExpenseModalOpen(true)}
				>
					Add Expense
				</Button>
			</div>
			<AddExpense tableOnly listSource="reporting" employeeId={employeeId} />
			<Modal
				title="Add Expense"
				open={expenseModalOpen}
				onCancel={() => setExpenseModalOpen(false)}
				footer={null}
				width={720}
				destroyOnClose
			>
				<AddExpense
					formOnly
					onCancel={() => setExpenseModalOpen(false)}
					onSuccess={() => dispatch(loadExpensesByReporting(employeeId))}
				/>
			</Modal>
		</div>
	);
};

export default Expense;
